"use client";

type InputFieldProps = {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  height?: string;
};

import React from 'react';

export default function InputField({
  label,
  placeholder,
  value,
  onChange,
  className = "",
  height,
}: InputFieldProps) {
  return (
    <div className={`flex flex-col gap-1 w-full ${className}`}>
      {label && <label className="text-sm text-808080-700">{label}</label>}

      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className="border border-DCDCDC text-1B1B1B px-3 py-3 outline-none bg-FFFFFF text-14-tamil-300 "
        style={{ height: height }}
      />
    </div>
  );
}
